module.exports = __webpack_public_path__ + "static/media/apple.ce97a66b.svg";